
import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import {
  NavbarAccess,
  NavbarMenuEntry,
  visibleEntries,
  contestsMenuEntries,
  coursesMenuEntries,
  problemsMenuEntries,
  rankingMenuEntries,
  helpMenuEntries,
} from './navbarMenus';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAward,
  faBalanceScale,
  faBook,
  faBookmark,
  faChalkboardTeacher,
  faChartLine,
  faClipboardCheck,
  faCode,
  faComments,
  faDatabase,
  faFileArchive,
  faFlagCheckered,
  faGraduationCap,
  faHistory,
  faLayerGroup,
  faList,
  faListOl,
  faMedal,
  faNewspaper,
  faPen,
  faPenNib,
  faPlusCircle,
  faRobot,
  faSchool,
  faTrophy,
  faVideo,
} from '@fortawesome/free-solid-svg-icons';
import NavbarItem from './NavbarItem.vue';

library.add(
  faAward,
  faBalanceScale,
  faBook,
  faBookmark,
  faChalkboardTeacher,
  faChartLine,
  faClipboardCheck,
  faCode,
  faComments,
  faDatabase,
  faFileArchive,
  faFlagCheckered,
  faGraduationCap,
  faHistory,
  faLayerGroup,
  faList,
  faListOl,
  faMedal,
  faNewspaper,
  faPen,
  faPenNib,
  faPlusCircle,
  faRobot,
  faSchool,
  faTrophy,
  faVideo,
);

@Component({
  components: {
    'omegaup-navbar-item': NavbarItem,
  },
})
export default class NavbarItems extends Vue {
  @Prop() omegaUpLockDown!: boolean;
  @Prop() inContest!: boolean;
  @Prop() isLoggedIn!: boolean;
  @Prop() isReviewer!: boolean;
  @Prop() isAdmin!: boolean;
  @Prop() isMainUserIdentity!: boolean;
  @Prop() navbarSection!: string;
  @Prop() isUnder13User!: boolean;

  T = T;

  get access(): NavbarAccess {
    return {
      isLoggedIn: this.isLoggedIn,
      isMainUserIdentity: this.isMainUserIdentity,
      isUnder13User: this.isUnder13User,
      isReviewer: this.isReviewer,
    };
  }

  get contestsEntries(): NavbarMenuEntry[] {
    return visibleEntries(contestsMenuEntries, this.access);
  }

  get coursesEntries(): NavbarMenuEntry[] {
    return visibleEntries(coursesMenuEntries, this.access);
  }

  get problemsEntries(): NavbarMenuEntry[] {
    return visibleEntries(problemsMenuEntries, this.access);
  }

  get rankingEntries(): NavbarMenuEntry[] {
    return visibleEntries(rankingMenuEntries, this.access);
  }

  get helpEntries(): NavbarMenuEntry[] {
    return visibleEntries(helpMenuEntries, this.access);
  }
}
